import React, { useState, useEffect, useRef } from 'react';
import { ArrowLeft, Download, Loader, X, RefreshCw, MapPin, FileText, Printer, Send, Plus, Save, Edit2, Filter, ChevronDown, ChevronUp, Globe } from 'lucide-react';
import apiService from '../config'; 
import FinalAwardNotice from '../Pages/FinalAwardNotice';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom'; // Add this import
import html2pdf from 'html2pdf.js';
import { useLanguage } from '../StoreContext/LanguageContext';

const HighwaySelectFormat = ({ onBack, projectId, setSelectedComponent, setSubComponent }) => {
    const { language, translations } = useLanguage();
    const navigate = useNavigate(); // Add this line
    const [showConfirm, setShowConfirm] = useState(false);
    const [finalAwardData, setFinalAwardData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [downloading, setDownloading] = useState(false);
    const [currentProjectId, setCurrentProjectId] = useState(null);
    const [currentProjectName, setCurrentProjectName] = useState(null);
    const [currentProposalId, setCurrentProposalId] = useState(null);
    const [tableData, setTableData] = useState([]);
    const [selectedOwnerIds, setSelectedOwnerIds] = useState([]);
    const [selectAll, setSelectAll] = useState(false); // Add this state
    const [currentLaoId, setCurrentLaoId] = useState([]);
    const [isKJPButtonClicked, setIsKJPButtonClicked] = useState(false);

    const [filters, setFilters] = useState({
        projectId: '',
        proposalId: '',
        district: '',
        taluka: '',
        village: ''
    });
    const [selectedOwners, setSelectedOwners] = useState([]); // Changed to array for multiple selections

    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [onConfirmAction, setOnConfirmAction] = useState(null);

    // Fetch user role
    const [userRole, setUserRole] = useState(null);

    useEffect(() => {
        try {
            const userData = localStorage.getItem("userData");
            if (userData) {
                const user = JSON.parse(userData);
                const role = user.user_role || user.user_role_name || null;
                setUserRole(role);
            }
        } catch (error) {
            console.error("Error parsing user data:", error);
        }
    }, []);

    // Proposal location states
    const [proposalData, setProposalData] = useState(null);
    // useEffect(() => {
    //     fetchProposalData();
    //     fetchusersLAO();
    // }, []);


    useEffect(() => {
        if (currentProjectId && currentProposalId) {
            fetchFinalAwardData();
            fetchusersLAO();
        }
        if (currentProposalId) {
            fetchProposalData();
        }
    }, [currentProjectId, currentProposalId]);

    // LAO 
    const [laoUser, setusersLAO] = useState([]);

    // Handle individual checkbox selection
    const handleOwnerSelection = (ownerId, isChecked) => {
        console.log("Owner selection changed:", { ownerId, isChecked, type: typeof ownerId });

        if (isChecked) {
            // Ensure we're not adding duplicates and the ID is valid
            if (ownerId != null && ownerId !== '' && !selectedOwnerIds.includes(ownerId)) {
                setSelectedOwnerIds(prev => [...prev, ownerId]);
            }
        } else {
            setSelectedOwnerIds(prev => prev.filter(id => id !== ownerId));
        }
    };

    // Handle select all checkbox
    const handleSelectAll = (isChecked) => {
        setSelectAll(isChecked);
        if (isChecked) {
            // Filter out any invalid IDs before setting
            const validOwnerIds = finalAwardData
                .map(item => item.id || item.land_owner_id)
                .filter(id => id != null && id !== '' && id !== undefined);

            console.log("Select all - valid owner IDs:", validOwnerIds);
            setSelectedOwnerIds(validOwnerIds);
        } else {
            setSelectedOwnerIds([]);
        }
    };

    // Update selectAll state when individual selections change
    useEffect(() => {
        if (finalAwardData.length > 0) {
            const allSelected = finalAwardData.every(item => selectedOwnerIds.includes(item.id));
            setSelectAll(allSelected);
        }
    }, [selectedOwnerIds, finalAwardData]);

    useEffect(() => {
        const getProjectId = () => {
            const currentProjectData = localStorage.getItem("currentProjectData");
            if (currentProjectData) {
                const projectData = JSON.parse(currentProjectData);
                return projectData.default_project || projectData.id;
            }

            const userData = localStorage.getItem("userData");
            if (userData) {
                const user = JSON.parse(userData);
                return user.default_project || user.data?.project_id || user.project_id;
            }

            return projectId || "";
        };

        const getProposalId = () => {
            const userData = localStorage.getItem("userData");
            if (userData) {
                try {
                    const user = JSON.parse(userData);
                    const laoUserId = user.usr_id;
                    setCurrentLaoId(laoUserId);
                    console.log(".............Current LAO login :", laoUserId);
                    return user.default_proposal || "";
                } catch (e) {
                    console.error("Error parsing user data for proposalId:", e);
                }
            }

            return "";
        };

        const detectedProjectId = getProjectId();
        const detectedProposalId = getProposalId();

        setCurrentProjectId(detectedProjectId);
        setCurrentProposalId(detectedProposalId);

        console.log("✅ Detected Project ID:", detectedProjectId);
        console.log("✅ Detected Proposal ID:", detectedProposalId);
    }, [projectId]);

    // const handleSendToNext = async () => {
    //     // Check if any records are selected
    //     if (selectedOwnerIds.length === 0) {
    //         toast.error("Please select at least one record to send to FinalAward");
    //         return;
    //     }
    //     if (!currentProjectId || !currentProposalId) {
    //         alert('Project ID and Proposal ID are required.');
    //         return;
    //     }

    //     const remarks = "FinalAward completed!";
    //     const ownerIds = selectedOwnerIds.join(','); // Convert array to comma-separated string 
    //     try {
    //         setLoading(true); // Show loading
    //         const formData = new FormData();
    //         formData.append('project_id', currentProjectId);
    //         formData.append('proposal_id', currentProposalId);
    //         formData.append('remarks', remarks);
    //         formData.append('usr_id', currentLaoId);
    //         formData.append('owner_id', ownerIds); // Send comma-separated string
    //         const response = await apiService.postTrackingKJP(formData);

    //         console.log('Send to KJP response:', response);

    //         if (response.status === 200) {
    //             alert(`Successfully sent ${selectedOwners.length} owner(s) to KJP!`);
    //             if (onBack) {
    //                 onBack('KJP'); // ✅ This is correct
    //             }
    //         }
    //         else {
    //             alert('Failed to send to KJP. Please try again.');
    //         }
    //     } catch (error) {
    //         console.error('Error sending to KJP:', error);
    //         alert('Failed to send to KJP. Please try again.');
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    // Function to transform backend data to component structure

    const handleSendToNext = () => {
        if (selectedOwnerIds.length === 0) {
            toast.error("Please select at least one record to send to FinalAward");
            return;
        }

        // Check if not all records are selected
        const allIds = finalAwardData.map(item => item.id);
        const unselectedIds = allIds.filter(id => !selectedOwnerIds.includes(id));

        if (unselectedIds.length > 0) {
            setOnConfirmAction(() => () => proceedSendToNext());
            setShowConfirmationModal(true);
        } else {
            proceedSendToNext();
        }
    };

    const proceedSendToNext = async () => {
        if (!currentProjectId || !currentProposalId) {
            alert('Project ID and Proposal ID are required.');
            return;
        }

        const remarks = "FinalAward completed!";

        // ✅ Send ALL owner IDs from tableData
        const ownerIds = finalAwardData
            .map(record => record.id)
            .filter(Boolean)
            .join(',');
        console.log("🧩 Sample record from finalAwardData:", finalAwardData[0]);

        console.log("🐞 finalAwardData:", finalAwardData);
        console.log("🐞 Extracted ownerIds:", ownerIds);

        if (!ownerIds || ownerIds.trim() === '') {
            toast.warning('No records found to send.');
            return;
        }

        try {
            setLoading(true);
            const formData = new FormData();
            formData.append('project_id', currentProjectId);
            formData.append('proposal_id', currentProposalId);
            formData.append('remarks', remarks);
            formData.append('usr_id', currentLaoId);
            formData.append('owner_id', ownerIds);

            const response = await apiService.postTrackingKJP(formData);
            console.log('Send to KJP response:', response);

            if (response.status === 200) {
                toast.success(`Successfully sent ${ownerIds.split(',').length} owner(s) to KJP!`);
                if (onBack) onBack('KabjaPauti'); // ← CHANGED FROM 'KJP' TO 'KabjaPauti'
                setIsKJPButtonClicked(true);
            } else {
                toast.error('Failed to send to KJP. Please try again.');
            }
        } catch (error) {
            console.error('Error sending to KJP:', error);
            toast.error('Failed to send to KJP. Please try again.');
        } finally {
            setLoading(false);
        }
    };



    // const transformBackendData = (backendData) => {
    //     return backendData.map((item, index) => {
    //         // Ensure we have a valid ID - use land_owner_id, fallback to index if needed
    //         const ownerId = item.land_owner_id || item.owner_id || item.id || `temp_${index}`;

    //         console.log("Transforming item:", {
    //             original_id: item.land_owner_id,
    //             final_id: ownerId,
    //             owner_name: item.owner_name
    //         });

    //         return {
    //             id: ownerId, // Primary ID for React and selection
    //             land_owner_id: item.land_owner_id, // Keep original field for reference
    //             owner_name: item.owner_name,
    //             surveyNo: item.survey_no || 'N/A',

    //             // Area information - converting from single land_area value
    //             area: {
    //                 hectare: Math.floor(item.land_area / 10000) || 0,
    //                 are: Math.floor((item.land_area % 10000) / 100) || 0,
    //                 sq_meter: item.land_area % 100 || 0
    //             },

    //             // Total area (assuming same as area for now)
    //             totalArea: {
    //                 hectare: Math.floor(item.land_area / 10000) || 0,
    //                 are: Math.floor((item.land_area % 10000) / 100) || 0,
    //                 sq_meter: item.land_area || 0
    //             },

    //             // Area acquired (using land_area as acquired area)
    //             acquiredArea: item.land_area || 0,

    //             // Land rate
    //             landRate: item.land_value_rate || 0,

    //             // Compensation amounts
    //             landCompensation: item.land_value_total || 0,
    //             structureCompensation: item.structure_value || 0,
    //             treeCompensation: item.tree_value || 0,
    //             otherCompensation: (item.crop_value || 0) + (item.water_body_value || 0) +
    //                 (item.other_asset_value || 0) + (item.borewell || 0) +
    //                 (item.home || 0) + (item.pipeline_value || 0) + (item.wire_value || 0),

    //             // Calculate total compensation
    //             totalCompensation: (item.land_value_total || 0) + (item.structure_value || 0) +
    //                 (item.tree_value || 0) + (item.crop_value || 0) +
    //                 (item.water_body_value || 0) + (item.other_asset_value || 0) +
    //                 (item.borewell || 0) + (item.home || 0) + (item.pipeline_value || 0) +
    //                 (item.wire_value || 0),

    //             // Solatium (30% of total compensation)
    //             solatium30: item.solatium_amount || 0,

    //             // Interest (12% - calculate based on total compensation + solatium)
    //             interestAward: ((item.land_value_total || 0) + (item.structure_value || 0) +
    //                 (item.tree_value || 0) + (item.crop_value || 0) +
    //                 (item.water_body_value || 0) + (item.other_asset_value || 0) +
    //                 (item.borewell || 0) + (item.home || 0) + (item.pipeline_value || 0) +
    //                 (item.wire_value || 0) + (item.solatium_amount || 0)) * 0.12,

    //             // Additional compensation (if any)
    //             additionalCompensation: 0,

    //             // Calculate total final award
    //             get totalFinalAward() {
    //                 return this.totalCompensation + this.solatium30 + this.interestAward + this.additionalCompensation;
    //             },

    //             // Remarks
    //             remarks: item.remarks || '',

    //             rawData: item
    //         };
    //     });
    // };

    // Enhanced CSV download function

    // Transform backend data to component structure
    const transformBackendData = (backendData) => {
        return backendData.map(item => {
            console.log('🔍 Backend item for transformation:', {
                land_owner_id: item.land_owner_id,
                owner_name: item.owner_name,
                survey_no: item.survey_no,
                forestTreeCompensationAmount: item.forest_tree_amount,
            });

            const ownerId = item.land_owner_id;

            if (!ownerId) {
                console.warn('⚠️ No land_owner_id found for item:', item);
            }

            // FIX: Use correct field names from API
            const structureCount = parseInt(item.no_of_structure ?? 0) || 0;
            const treeCount = parseInt(item.no_of_tree ?? 0) || 0;
            const cropCount = parseInt(item.no_of_crop ?? 0) || 0;
            const waterBodyCount = parseInt(item.no_of_water_body ?? 0) || 0;
            const borewellCount = parseInt(item.no_of_borewell ?? 0) || 0;
            const homeCount = parseInt(item.no_of_home ?? 0) || 0;
            const pipelineCount = parseInt(item.no_of_pipeline ?? 0) || 0;
            const tinshedCount = parseInt(item.no_of_tinshed ?? 0) || 0;
            const wireCount = parseInt(item.no_of_wirefencing ?? 0) || 0;
            const otherAssetCount = parseInt(item.no_of_other_asset ?? 0) || 0;

            // Get actual compensation amounts
            const structureCompensationAmount = parseFloat(item.structure_amount ?? 0) || 0;
            const treeCompensationAmount = parseFloat(item.tree_amount ?? 0) || 0;
            const forestTreeCompensationAmount = parseFloat(item.forest_tree_amount ?? 0) || 0;
            const cropCompensationAmount = parseFloat(item.crop_amount ?? 0) || 0;
            const waterBodyCompensationAmount = parseFloat(item.water_body_amount ?? 0) || 0;
            const borewellCompensationAmount = parseFloat(item.borewell_amount ?? 0) || 0;
            const homeCompensationAmount = parseFloat(item.home_amount ?? 0) || 0;
            const pipelineCompensationAmount = parseFloat(item.pipeline_amount ?? 0) || 0;
            const tinshedCompensationAmount = parseFloat(item.tinshed_amount ?? 0) || 0;
            const wireCompensationAmount = parseFloat(item.wire_amount ?? 0) || 0;
            const otherAssetCompensationAmount = parseFloat(item.other_asset_amount ?? 0) || 0;
            const solatiumAmount = parseFloat(item.solatium_compensation_amount ?? 0) || 0;
            const interestAmount = parseFloat(item.interest_amount ?? 0) || 0;
            const additionalCompensation = parseFloat(item.additional_compensation ?? 0) || 0;
            const totalCompensation = parseFloat(item.total_compensation ?? 0) || 0;

            // Use owner_aqr_area for acquired area
            const acquiredAreaValue = parseFloat(item.owner_aqr_area ?? 0) || 0;

            // Calculate land compensation from API data
            const landValueTotal = parseFloat(item.land_amount ?? 0) || 0;

            // Calculate base compensation total
            const baseCompensationTotal = landValueTotal + structureCompensationAmount + treeCompensationAmount + forestTreeCompensationAmount + cropCompensationAmount + waterBodyCompensationAmount + borewellCompensationAmount + homeCompensationAmount + pipelineCompensationAmount + tinshedCompensationAmount + wireCompensationAmount + otherAssetCompensationAmount;

            // Calculate land rate
            let landRate = 0;
            if (item.land_rate) {
                landRate = parseFloat(item.land_rate);
            } else if (landValueTotal && acquiredAreaValue > 0) {
                landRate = landValueTotal / acquiredAreaValue;
            }

            // Convert acquired area to hectare/are/sq_meter format
            const totalSqMeters = acquiredAreaValue;
            const hectares = Math.floor(totalSqMeters / 10000);
            const remainingAfterHectares = totalSqMeters % 10000;
            const ares = Math.floor(remainingAfterHectares / 100);
            const sqMeters = remainingAfterHectares % 100;

            // Calculate totals step by step
            // First Total: Land + Tree + Home + Tinshed + Water Body + Borewell + Structure
            const firstTotal = Number(
                (
                    (Number(landValueTotal) * 2 || 0) +
                    (Number(treeCompensationAmount) || 0) +
                    (Number(forestTreeCompensationAmount) || 0) +
                    (Number(homeCompensationAmount) || 0) +
                    (Number(tinshedCompensationAmount) || 0) +
                    (Number(waterBodyCompensationAmount) || 0) +
                    (Number(borewellCompensationAmount) || 0) +
                    (Number(structureCompensationAmount) || 0)
                ).toFixed(2)
            );

            // Second Total: First Total + Solatium + Interest + Pipeline + Other compensations
            const secondTotal = Number(
                (
                    (Number(firstTotal) || 0) +
                    (Number(solatiumAmount) || 0) +
                    (Number(interestAmount) || 0) +
                    (Number(pipelineCompensationAmount) || 0) +
                    (Number(cropCompensationAmount) || 0) +
                    (Number(wireCompensationAmount) || 0) +
                    (Number(otherAssetCompensationAmount) || 0)
                ).toFixed(2)
            );

            // Third Total: Use total compensation from API or calculated second total
            const thirdTotal = secondTotal;

            return {
                id: ownerId,
                compId: ownerId,
                landOwnerId: ownerId,
                owner_name: item.owner_name,
                surveyNo: item.survey_no || 'N/A',

                irrigableArea: item.owner_irrigable_area,
                nonIrrigableArea: item.owner_non_irrigable_area,
                ownerAquareArea: item.owner_aqr_area,
                ownerTotalArea: item.owner_total_area,
                natureOfOwner: item.nature_of_owner,
                actualOccupant: item.actual_occupant,

                // Area information
                area: {
                    hectare: hectares,
                    are: ares,
                    sq_meter: sqMeters
                },

                totalArea: {
                    hectare: hectares,
                    are: ares,
                    sq_meter: totalSqMeters
                },

                // Store complete raw backend data for editing
                rawData: item,

                // Acquired area
                acquiredArea: acquiredAreaValue,

                // Land rate and amount
                landRate: landRate,
                landAmount: landValueTotal, // Fixed: use landValueTotal instead of item.land_amount

                // Asset counts
                structureCount: structureCount,
                treeCount: treeCount,
                cropCount: cropCount,
                waterBodyCount: waterBodyCount,
                borewellCount: borewellCount,
                homeCount: homeCount,
                pipelineCount: pipelineCount,
                tinshedCount: tinshedCount,
                wireCount: wireCount,
                otherAssetCount: otherAssetCount,

                // Compensation presence flags
                landCount: (landValueTotal && landValueTotal > 0) ? 1 : 0,
                structureCompensationExists: (structureCompensationAmount && structureCompensationAmount > 0) ? 1 : 0,
                treeCompensationExists: (treeCompensationAmount && treeCompensationAmount > 0) ? 1 : 0,
                forestTreeCompensationExists: (forestTreeCompensationAmount && forestTreeCompensationAmount > 0) ? 1 : 0,
                otherCompensationExists: ((cropCompensationAmount && cropCompensationAmount > 0) ? 1 : 0) +
                    ((waterBodyCompensationAmount && waterBodyCompensationAmount > 0) ? 1 : 0) +
                    ((borewellCompensationAmount && borewellCompensationAmount > 0) ? 1 : 0) +
                    ((homeCompensationAmount && homeCompensationAmount > 0) ? 1 : 0) +
                    ((pipelineCompensationAmount && pipelineCompensationAmount > 0) ? 1 : 0) +
                    ((tinshedCompensationAmount && tinshedCompensationAmount > 0) ? 1 : 0) +
                    ((wireCompensationAmount && wireCompensationAmount > 0) ? 1 : 0) +
                    ((otherAssetCompensationAmount && otherAssetCompensationAmount > 0) ? 1 : 0),

                // Add otherCount for proper calculation
                otherCount: cropCount + waterBodyCount + borewellCount + homeCount + pipelineCount + tinshedCount + wireCount + otherAssetCount,

                // Compensation amounts
                landCompensation: landValueTotal,
                structureCompensation: structureCompensationAmount,
                treeCompensation: treeCompensationAmount,
                forestTreeCompensation: forestTreeCompensationAmount,
                cropCompensation: cropCompensationAmount,
                waterBodyCompensation: waterBodyCompensationAmount,
                borewellCompensation: borewellCompensationAmount,
                homeCompensation: homeCompensationAmount,
                pipelineCompensation: pipelineCompensationAmount,
                tinshedCompensation: tinshedCompensationAmount,
                wireCompensation: wireCompensationAmount,
                otherAssetCompensation: otherAssetCompensationAmount,

                // Combined other compensation
                otherCompensation: cropCompensationAmount + waterBodyCompensationAmount + borewellCompensationAmount + homeCompensationAmount + pipelineCompensationAmount + tinshedCompensationAmount + wireCompensationAmount + otherAssetCompensationAmount,

                // Base compensation total
                baseCompensationTotal: baseCompensationTotal,

                // Final amounts from API
                solatium30: solatiumAmount,
                interestAward: interestAmount,
                additionalCompensation: additionalCompensation,
                totalFinalAward: totalCompensation,
                // Remarks
                remarks: item.remarks || '',

                // Corrected totals calculation
                firstTotal: firstTotal,
                secondTotal: secondTotal,
                thirdTotal: thirdTotal
            };
        });
    };

    const downloadCSV = () => {
        try {
            const headers = [
                'Sr. No.',
                'Owner Name',
                'Survey No.',
                'Area Ha',
                'Area Are',
                'Area Sq.M',
                'Total Area Ha',
                'Total Area Are',
                'Total Area Sq.M',
                'Area Acquired (Sq.M)',
                'Land Rate (₹)',
                'Land Compensation (₹)',
                'Structure Compensation (₹)',
                'Tree Compensation (₹)',
                'Others Compensation (₹)',
                'Total Compensation (₹)',
                '30% Solatium (₹)',
                '12% Interest (₹)',
                'Additional Amount (₹)',
                'Total Final Award (₹)',
                'Remarks'
            ];

            const csvContent = [
                headers.join(','),
                ...finalAwardData.map((row, index) => [
                    index + 1,
                    `"${row.owner_name || 'N/A'}"`,
                    `"${row.surveyNo || 'N/A'}"`,
                    row.area?.hectare || 0,
                    row.area?.are || 0,
                    row.area?.sq_meter || 0,
                    row.totalArea?.hectare || 0,
                    row.totalArea?.are || 0,
                    row.totalArea?.sq_meter || 0,
                    row.acquiredArea || 0,
                    row.landRate || 0,
                    row.landCompensation || 0,
                    row.structureCompensation || 0,
                    row.treeCompensation || 0,
                    row.otherCompensation || 0,
                    row.totalCompensation || 0,
                    row.solatium30 || 0,
                    row.interestAward || 0,
                    row.additionalCompensation || 0,
                    row.totalFinalAward || 0,
                    `"${row.remarks || '-'}"`
                ].join(','))
            ].join('\n');

            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', `Final_Award_Report_${currentProjectId}_${new Date().toISOString().split('T')[0]}.csv`);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            toast.success('CSV file downloaded successfully!');
            setShowConfirm(false);
        } catch (error) {
            console.error('Error generating CSV:', error);
            toast.error('Failed to generate CSV file');
        }
    };

    // Enhanced PDF download function
    const generatePDFDownload = () => {
        try {
            setDownloading(true);

            // Calculate totals from actual data
            const totals = {
                totalIrrigableArea: finalAwardData.reduce((sum, row) => sum + parseFloat(row.irrigableArea || 0), 0),
                totalNonIrrigableArea: finalAwardData.reduce((sum, row) => sum + parseFloat(row.nonIrrigableArea || 0), 0),
                totalAquareArea: finalAwardData.reduce((sum, row) => sum + parseFloat(row.ownerAquareArea || 0), 0),
                totalLandAmount: finalAwardData.reduce((sum, row) => sum + parseFloat(row.landAmount || 0), 0),
                totalTreeCompensation: finalAwardData.reduce((sum, row) => sum + parseFloat(row.treeCompensation || 0), 0),
                totalHomeAndTinshed: finalAwardData.reduce((sum, row) => sum + parseFloat(row.homeCompensation || 0) + parseFloat(row.tinshedCompensation || 0), 0),
                totalWaterBodyAndBorewell: finalAwardData.reduce((sum, row) => sum + parseFloat(row.waterBodyCompensation || 0) + parseFloat(row.borewellCompensation || 0), 0),
                totalStructureCompensation: finalAwardData.reduce((sum, row) => sum + parseFloat(row.structureCompensation || 0), 0),
                totalFirstTotal: finalAwardData.reduce((sum, row) => sum + parseFloat(row.firstTotal || 0), 0),
                totalSolatium: finalAwardData.reduce((sum, row) => sum + parseFloat(row.solatium30 || 0), 0),
                totalInterest: finalAwardData.reduce((sum, row) => sum + parseFloat(row.interestAward || 0), 0),
                totalPipeline: finalAwardData.reduce((sum, row) => sum + parseFloat(row.pipelineCompensation || 0), 0),
                totalSecondTotal: finalAwardData.reduce((sum, row) => sum + parseFloat(row.secondTotal || 0), 0),
                totalThirdTotal: finalAwardData.reduce((sum, row) => sum + parseFloat(row.thirdTotal || 0), 0)
            };

            console.log('Calculated totals:', totals);

            // Generate table rows with Tailwind CSS classes
            const tableRows = finalAwardData.map((row, index) => {
                const homeAndTinshed = (parseFloat(row.homeCompensation || 0) + parseFloat(row.tinshedCompensation || 0));
                const waterBodyAndBorewell = (parseFloat(row.waterBodyCompensation || 0) + parseFloat(row.borewellCompensation || 0));
                const landAmountDouble = parseFloat(row.landAmount || 0) * 2;

                return `
                <tr class="border-b border-gray-800">
                    <td class="border border-black px-1 py-1 text-center text-xs">${index + 1}</td>
                    <td class="border border-black px-1 py-1 text-left text-xs max-w-20 break-words">${row.owner_name || 'N/A'}</td>
                    <td class="border border-black px-1 py-1 text-center text-xs">${row.surveyNo || 'N/A'}</td>
                    <td class="border border-black px-1 py-1 text-center text-xs">${row.irrigableArea || '0'}</td>
                    <td class="border border-black px-1 py-1 text-center text-xs">${row.nonIrrigableArea || '0'}</td>
                    <td class="border border-black px-1 py-1 text-center text-xs">${row.ownerAquareArea || '0'}</td>
                    <td class="border border-black px-1 py-1 text-right text-xs">${(row.landRate || 0).toLocaleString()}</td>
                    <td class="border border-black px-1 py-1 text-right text-xs">${(row.landAmount || 0).toLocaleString()}</td>
                    <td class="border border-black px-1 py-1 text-right text-xs">${landAmountDouble.toLocaleString()}</td>
                    <td class="border border-black px-1 py-1 text-right text-xs">${(row.treeCompensation || 0).toLocaleString()}</td>
                    <td class="border border-black px-1 py-1 text-right text-xs">${homeAndTinshed.toLocaleString()}</td>
                    <td class="border border-black px-1 py-1 text-right text-xs">${waterBodyAndBorewell.toLocaleString()}</td>
                    <td class="border border-black px-1 py-1 text-right text-xs">${(row.structureCompensation || 0).toLocaleString()}</td>
                    <td class="border border-black px-1 py-1 text-right text-xs">${(row.firstTotal || 0).toLocaleString()}</td>
                    <td class="border border-black px-1 py-1 text-right text-xs">${(row.solatium30 || 0).toLocaleString()}</td>
                    <td class="border border-black px-1 py-1 text-right text-xs">${(row.interestAward || 0).toLocaleString()}</td>
                    <td class="border border-black px-1 py-1 text-right text-xs">${(row.pipelineCompensation || 0).toLocaleString()}</td>
                    <td class="border border-black px-1 py-1 text-right text-xs">${(row.secondTotal || 0).toLocaleString()}</td>
                    <td class="border border-black px-1 py-1 text-right text-xs">0</td>
                    <td class="border border-black px-1 py-1 text-right text-xs">0</td>
                    <td class="border border-black border-l-2 px-1 py-1 text-right text-xs font-bold">${(row.thirdTotal || 0).toLocaleString()}</td>
                </tr>
            `;
            }).join('');

            const printContent = `
            <!DOCTYPE html>
            <html lang="hi">
            <head>
                <meta charset="UTF-8">
                <meta name="viewport" content="width=device-width, initial-scale=1.0">
                <title>Compensation Award Report</title>
                <script src="https://cdn.tailwindcss.com"></script>
                <link href="https://fonts.googleapis.com/css2?family=Noto+Sans+Devanagari:wght@400;600;700&display=swap" rel="stylesheet">
                <script>
                    tailwind.config = {
                        theme: {
                            extend: {
                                fontFamily: {
                                    'noto': ['Noto Sans Devanagari', 'Arial', 'sans-serif']
                                }
                            }
                        }
                    }
                </script>
            </head>
            <body class="font-noto text-xs text-black bg-white p-2 leading-tight">
                <!-- Header Section -->
                <div class="text-center mb-5 border-b-2 border-black pb-4">
                    <h1 class="text-lg font-bold mb-2 text-black">अंतीम निवाडा (Final Award)</h1>
                    <h2 class="text-sm font-semibold mb-2 text-gray-800">Land Acquisition Compensation Details</h2>
                    <h3 class="text-xs text-gray-600">Project ID: ${currentProjectId || 'N/A'}</h3>
                </div>

                <!-- Main Table -->
                <div class="overflow-x-auto">
                    <table class="w-full border-2 border-black border-collapse text-xs">
                        <thead>
                            <!-- Main Header Row -->
                            <tr class="bg-gray-100">
                                <th rowspan="3" class="border border-black px-1 py-2 text-center font-bold text-xs">Sr.<br>No.</th>
                                <th rowspan="3" class="border border-black px-1 py-2 text-center font-bold text-xs">Owner Name</th>
                                <th rowspan="3" class="border border-black px-1 py-2 text-center font-bold text-xs">Survey<br>No.</th>
                                <th colspan="3" class="border border-black px-1 py-2 text-center font-bold text-xs">Acquired Area (in Hectares)</th>
                                <th rowspan="3" class="border border-black px-1 py-2 text-center font-bold text-xs">Recorded Value + Partial Purchase Land Rate per hectare</th>
                                <th rowspan="3" class="border border-black px-1 py-2 text-center font-bold text-xs">Recorded Value + Partial Purchase Land Market Value</th>
                                <th rowspan="3" class="border border-black px-1 py-2 text-center font-bold text-xs">Land Market Value × 2 Factor (No.8 * 2 Factor)</th>
                                <th rowspan="3" class="border border-black px-1 py-2 text-center font-bold text-xs">Tree Valuation<br>Comp.</th>
                                <th rowspan="3" class="border border-black px-1 py-2 text-center font-bold text-xs">Construction Value (Home+Tinshed)</th>
                                <th rowspan="3" class="border border-black px-1 py-2 text-center font-bold text-xs">Well/Borewell (WaterBody + Well/Borewell)<br>Comp.</th>
                                <th rowspan="3" class="border border-black px-1 py-2 text-center font-bold text-xs">Structure Valuation</th>
                                <th rowspan="3" class="border border-black px-1 py-2 text-center font-bold text-xs">Total Amount (Sum of columns 9+10+11+12+13)</th>
                                <th rowspan="3" class="border border-black px-1 py-2 text-center font-bold text-xs">100% Relief Amount</th>
                                <th rowspan="3" class="border border-black px-1 py-2 text-center font-bold text-xs">12% Interest Amount from 25-05-2018 to 05-04-2023</th>
                                <th rowspan="3" class="border border-black px-1 py-2 text-center font-bold text-xs">Pipeline</th>
                                <th rowspan="3" class="border border-black px-1 py-2 text-center font-bold text-xs">Total Amount (Sum of 14+15+16+17)</th>
                                <th rowspan="3" class="border border-black px-1 py-2 text-center font-bold text-xs">50% Advance Compensation Deduction</th>
                                <th rowspan="3" class="border border-black px-1 py-2 text-center font-bold text-xs">50% Advance Interest Deduction till 05-04-2023</th>
                                <th rowspan="3" class="border border-black px-1 py-2 text-center font-bold text-xs">Net Payable Amount(18 - (19+20))</th>
                            </tr>
                            
                            <!-- Sub Header Row -->
                            <tr class="bg-gray-100">
                                <th class="border border-black px-1 py-1 text-center font-bold text-xs">Irrigable</th>
                                <th class="border border-black px-1 py-1 text-center font-bold text-xs">Non-Irr.</th>
                                <th class="border border-black px-1 py-1 text-center font-bold text-xs">Total</th>
                            </tr>
                            
                            <!-- Column Numbers Row -->
                            <tr class="bg-gray-200">
                                <th class="border border-black px-1 py-1 text-center font-semibold text-xs">1</th>
                                <th class="border border-black px-1 py-1 text-center font-semibold text-xs">2</th>
                                <th class="border border-black px-1 py-1 text-center font-semibold text-xs">3</th>
                                <th class="border border-black px-1 py-1 text-center font-semibold text-xs">4</th>
                                <th class="border border-black px-1 py-1 text-center font-semibold text-xs">5</th>
                                <th class="border border-black px-1 py-1 text-center font-semibold text-xs">6</th>
                                <th class="border border-black px-1 py-1 text-center font-semibold text-xs">7</th>
                                <th class="border border-black px-1 py-1 text-center font-semibold text-xs">8</th>
                                <th class="border border-black px-1 py-1 text-center font-semibold text-xs">9</th>
                                <th class="border border-black px-1 py-1 text-center font-semibold text-xs">10</th>
                                <th class="border border-black px-1 py-1 text-center font-semibold text-xs">11</th>
                                <th class="border border-black px-1 py-1 text-center font-semibold text-xs">12</th>
                                <th class="border border-black px-1 py-1 text-center font-semibold text-xs">13</th>
                                <th class="border border-black px-1 py-1 text-center font-semibold text-xs">14</th>
                                <th class="border border-black px-1 py-1 text-center font-semibold text-xs">15</th>
                                <th class="border border-black px-1 py-1 text-center font-semibold text-xs">16</th>
                                <th class="border border-black px-1 py-1 text-center font-semibold text-xs">17</th>
                                <th class="border border-black px-1 py-1 text-center font-semibold text-xs">18</th>
                                <th class="border border-black px-1 py-1 text-center font-semibold text-xs">19</th>
                                <th class="border border-black px-1 py-1 text-center font-semibold text-xs">20</th>
                                <th class="border border-black px-1 py-1 text-center font-semibold text-xs">21</th>
                            </tr>
                        </thead>
                        
                        <tbody>
                            ${tableRows}
                            
                            <!-- Totals Row -->
                            <tr class="bg-gray-100 border-t-2 border-black">
                                <td class="border border-black px-1 py-1 text-center font-bold text-xs">एकूण</td>
                                <td class="border border-black px-1 py-1"></td>
                                <td class="border border-black px-1 py-1"></td>
                                <td class="border border-black px-1 py-1 text-right font-bold text-xs">${totals.totalIrrigableArea.toFixed(2)}</td>
                                <td class="border border-black px-1 py-1 text-right font-bold text-xs">${totals.totalNonIrrigableArea.toFixed(2)}</td>
                                <td class="border border-black px-1 py-1 text-right font-bold text-xs">${totals.totalAquareArea.toFixed(2)}</td>
                                <td class="border border-black px-1 py-1"></td>
                                <td class="border border-black px-1 py-1 text-right font-bold text-xs">${totals.totalLandAmount.toLocaleString()}</td>
                                <td class="border border-black px-1 py-1 text-right font-bold text-xs">${(totals.totalLandAmount * 2).toLocaleString()}</td>
                                <td class="border border-black px-1 py-1 text-right font-bold text-xs">${totals.totalTreeCompensation.toLocaleString()}</td>
                                <td class="border border-black px-1 py-1 text-right font-bold text-xs">${totals.totalHomeAndTinshed.toLocaleString()}</td>
                                <td class="border border-black px-1 py-1 text-right font-bold text-xs">${totals.totalWaterBodyAndBorewell.toLocaleString()}</td>
                                <td class="border border-black px-1 py-1 text-right font-bold text-xs">${totals.totalStructureCompensation.toLocaleString()}</td>
                                <td class="border border-black px-1 py-1 text-right font-bold text-xs">${totals.totalFirstTotal.toLocaleString()}</td>
                                <td class="border border-black px-1 py-1 text-right font-bold text-xs">${totals.totalSolatium.toLocaleString()}</td>
                                <td class="border border-black px-1 py-1 text-right font-bold text-xs">${totals.totalInterest.toLocaleString()}</td>
                                <td class="border border-black px-1 py-1 text-right font-bold text-xs">${totals.totalPipeline.toLocaleString()}</td>
                                <td class="border border-black px-1 py-1 text-right font-bold text-xs">${totals.totalSecondTotal.toLocaleString()}</td>
                                <td class="border border-black px-1 py-1 text-right font-bold text-xs">0</td>
                                <td class="border border-black px-1 py-1 text-right font-bold text-xs">0</td>
                                <td class="border border-black border-l-2 px-1 py-1 text-right font-bold text-xs">${totals.totalThirdTotal.toLocaleString()}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Footer Section -->
                <div class="text-center mt-4 text-xs text-gray-600 border-t border-gray-300 pt-2">
                    <p class="font-bold">अंतीम निवाडा तक्ता (Final Award Table)</p>
                    <p class="mt-1">Land Acquisition Compensation Report | Page 1 of 1</p>
                    <p class="mt-1">Generated on ${new Date().toLocaleString('en-IN')} | Project ID: ${currentProjectId || 'N/A'}</p>
                </div>
            </body>
            </html>
        `;

            console.log('HTML content created, length:', printContent.length);

            // Check if html2pdf is available
            if (typeof html2pdf === 'undefined') {
                throw new Error('html2pdf library is not loaded. Please include the script: https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js');
            }

            // Create blob and download directly
            const opt = {
                margin: [8, 8, 8, 8],
                filename: `अंतीम_निवाडा(finalAward)_${new Date().toISOString().split('T')[0]}.pdf`,
                image: { type: 'jpeg', quality: 0.95 },
                html2canvas: {
                    scale: 1.5,
                    useCORS: true,
                    allowTaint: true,
                    backgroundColor: '#ffffff',
                    logging: false,
                    width: 1800,
                    height: 800
                },
                jsPDF: {
                    unit: 'mm',
                    format: 'a3',
                    orientation: 'landscape',
                    compress: true
                }
            };

            console.log('Starting PDF generation...');

            // Generate PDF directly from HTML string
            html2pdf().set(opt).from(printContent).outputPdf('blob').then((pdfBlob) => {
                // Create download link
                const url = window.URL.createObjectURL(pdfBlob);
                const link = document.createElement('a');
                link.href = url;
                link.download = opt.filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);

                console.log('PDF downloaded successfully');

                // Show success message
                if (typeof toast !== 'undefined') {
                    toast.success('PDF downloaded successfully!');
                } else {
                    alert('PDF downloaded successfully!');
                }
            }).catch((error) => {
                throw error;
            });

        } catch (error) {
            console.error('PDF Generation Error:', error);
            console.error('Error stack:', error.stack);

            if (typeof setError !== 'undefined') {
                setError(`Failed to download PDF: ${error.message}`);
            }

            if (typeof toast !== 'undefined') {
                toast.error(`Failed to generate PDF: ${error.message}`);
            } else {
                alert(`Failed to generate PDF: ${error.message}`);
            }

        } finally {
            setDownloading(false);
            console.log('PDF download process completed');
        }
    };

    // Enhanced API download with better error handling
    const handleApiDownload = async () => {
        if (!apiService.downloadFinalAward) {
            toast.error('API download method not available');
            return;
        }

        try {
            setDownloading(true);
            await apiService.downloadFinalAward(currentProjectId, currentProposalId, 'pdf');
            setShowConfirm(false);
            toast.success('File downloaded successfully!');
        } catch (error) {
            console.error('API download failed:', error);
            toast.error('API download failed. Please try other download options.');
        } finally {
            setDownloading(false);
        }
    };

    // Alternative download methods
    const fetchFinalAwardData = async () => {
        try {
            setLoading(true);
            setError(null);

            if (!currentProjectId || !currentProposalId) {
                throw new Error('Both Project ID and Proposal ID are required.');
            }

            const response = await apiService.getFinalAward(currentProjectId, currentProposalId);

            let rawData = [];
            if (response && response.data) {
                rawData = Array.isArray(response.data) ? response.data : [response.data];
            } else if (Array.isArray(response)) {
                rawData = response;
            }

            const transformedData = transformBackendData(rawData);
            setFinalAwardData(transformedData);
            setTableData(transformedData); // <-- This populates tableData so owner IDs can be extracted

        } catch (err) {
            console.error('Error fetching final award data:', err);
            setError(err.message || 'Failed to fetch final award data. Please try again.');
            setFinalAwardData([]);
        } finally {
            setLoading(false);
        }
    };

    const calculateTotals = () => {
        if (!finalAwardData || finalAwardData.length === 0) return {};

        return {
            totalAreaHa: finalAwardData.reduce((sum, row) => sum + (row.area?.hectare || 0), 0),
            totalAreaAre: finalAwardData.reduce((sum, row) => sum + (row.area?.are || 0), 0),
            totalAreaSqM: finalAwardData.reduce((sum, row) => sum + (row.area?.sq_meter || 0), 0),
            totalAcquiredArea: finalAwardData.reduce((sum, row) => sum + (row.acquiredArea || 0), 0),
            totalCompensation: finalAwardData.reduce((sum, row) => sum + (row.totalCompensation || 0), 0),
            totalSolatium: finalAwardData.reduce((sum, row) => sum + (row.solatium30 || 0), 0),
            totalInterest: finalAwardData.reduce((sum, row) => sum + (row.interestAward || 0), 0),
            totalAdditional: finalAwardData.reduce((sum, row) => sum + (row.additionalCompensation || 0), 0),
            totalFinalAward: finalAwardData.reduce((sum, row) => sum + (row.totalFinalAward || 0), 0)
        };
    };

    // ProposalData
    const fetchProposalData = () => {
        try {
            const storedProposal = JSON.parse(localStorage.getItem('selectedProposal') || '{}');
            setProposalData(storedProposal || {});
        } catch (error) {

        }
    };

    // fetch LAO users
    const fetchusersLAO = async () => {
        const role = 3;

        try {
            const response = await apiService.getAssignLAO(role, currentProjectId, currentProposalId);
            console.log('LAO users:', response);
            if (response.status === 200 && response.data) {
                setusersLAO(Array.isArray(response.data) ? response.data : []);
            } else {
                setusersLAO([]);
            }
        } catch (error) {
            console.error('Error fetching LAO users:', error);
            setusersLAO([]);
        } finally {

        }
    };

    const tableRef = useRef(null);

    const handlePrint = () => {
        const printContents = tableRef.current.innerHTML;
        const win = window.open("", "_blank");
        win.document.write(`
    <html>
      <head>
        <title>अंतिम निवाडा</title>
        <link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">
        <style>
          @page {
            size: A3 landscape;
            margin-top: 0.19in;
          margin-bottom: 0.25in;
          margin-left: 0.81in;
          margin-right: 0.5in;
          }
          body {
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
            font-family: 'DVOT-Surekh', 'Mangal', 'Arial', sans-serif;
          }
          table {
            width: 100% !important;
            border-collapse: collapse;
            page-break-inside: auto;
            font-size: 10px;   /* ✅ छोटा font */
            zoom: 85%;
          }
          tr {
            page-break-inside: avoid;
          }
          thead { display: table-header-group; }
          tfoot { display: table-footer-group; }
          .no-print { display: none !important; }

          .header {
            text-align: center;
            padding-bottom: 1rem; /* p-2 */
            margin-top:0.5rem;
          }
                    
          * {
            background: transparent !important;
          }
          td, th {
            background: transparent !important;
            color: black !important;  
            border: 1px solid black;  
          }
        .signature {
            margin-top: 100px;
            text-align: right;
            font-weight: bold;
            display: block !important;   /* force display */
            visibility: visible !important;
        }

        </style>
      </head>
      <body class="p-6">
        <div class="header">
            <p>उपजिल्हाधिकारी, भू-संपादन, (मध्यम प्रकल्प), जिल्हाधिकारी कार्यालय, बुलढाणा</p>
            <p>भूसंपादन प्रकरण क्रमांक ${proposalData.section_11_bhusampadan_no} मोजे <b>${proposalData.village_name || ''}</b> ता. <b>${proposalData.taluka_name || ''}</b> जिल्हा <b>${proposalData.dist_name || ''}</b></p>
            <p>अंतिम निवाडा ई विवरणपत्र (दुरुस्ती दिनांक 02/05/2023)</p>
        </div>
        <div class="overflow-x-auto">
          ${printContents}
        </div>
        <div class="signature">
            <div>${laoUser?.[0]?.full_name || ''}</div>
            <div>${laoUser?.[0]?.designation || ''}</div>
        </div>
        <script>
          window.onload = function() {
            window.print();
          }
        </script>
      </body>
    </html>
  `);
        win.document.close();
    };

    const totals = calculateTotals();

    if (loading) {
        return (
            <div className="w-full bg-white min-h-screen flex items-center justify-center">
                <div className="flex flex-col items-center space-y-4">
                    <Loader className="h-8 w-8 animate-spin text-blue-500" />
                    <p className="text-gray-600">{translations[language].LoadingFinalAwardData}</p>
                </div>
            </div>
        );
    }

    return (
        <div className="w-full bg-white min-h-screen">
            {/* Header */}
            <div className="p-6 border-b bg-gray-50">
                <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-6">
                        <button
                            onClick={onBack}
                            className="p-2 hover:bg-white hover:bg-opacity-20 rounded-full transition-colors"
                        >
                            <ArrowLeft className="h-5 w-5" />
                        </button>
                    </div>

                    <div className="flex items-center space-x-2">
                        {/* Selection Info */}
                        {selectedOwnerIds.length > 0 && (
                            <div className="px-3 py-2 bg-blue-100 text-blue-800 rounded-lg text-sm">
                                {selectedOwnerIds.length} {translations[language].recordsSelected}
                            </div>
                        )}
                        <button
                            className="flex items-center px-4 py-2 rounded-xl shadow-lg transition-all duration-200 bg-orange-700 hover:bg-orange-800 text-white"
                            onClick={() => {
                                setSubComponent("CompensationAmount")
                            }}
                        >
                            {translations[language].CompensationAmount}
                        </button>
                        {/* <button
                            className="flex items-center px-4 py-2 rounded-xl shadow-lg transition-all duration-200 bg-purple-700 hover:bg-purple-800 text-white"
                            onClick={() => {
                                setSubComponent("LandAcquisitionCerti")
                            }}
                        >
                            {translations[language].LandAcquisitionCerti}
                        </button>
                        {userRole === 3 && (
                            <button
                                onClick={proceedSendToNext}
                                // disabled={selectedOwnerIds.length === 0}
                                className={`px-4 py-2 rounded-xl shadow-md font-semibold transition-all duration-200 ${isKJPButtonClicked ? 'bg-red-600 text-white' : 'bg-blue-600 text-white hover:bg-blue-700'
                                    }`}
                            >
                                {translations[language].sendToKJP}
                            </button>
                        )} */}

                        <button
                            onClick={handlePrint}
                            disabled={downloading || finalAwardData.length === 0}
                            className="flex items-center space-x-2 px-4 py-2 bg-green-500 hover:bg-green-600 disabled:bg-gray-400 text-white rounded-lg transition-colors"
                        >
                            {downloading ? (
                                <>
                                    <Loader className="h-4 w-4 animate-spin" />
                                    <span>{translations[language].downloading}</span>
                                </>
                            ) : (
                                <>
                                    <Download className="h-4 w-4" />
                                    <span>{translations[language].Print}</span>
                                </>
                            )}
                        </button>

                        <button
                            className="flex items-center px-4 py-2 rounded-xl shadow-lg transition-all duration-200 bg-sky-700 hover:bg-sky-800 text-white"
                            onClick={() => {
                                console.log('Section23 button clicked'); // Debug log
                                // setSelectedComponent("Section23");
                                localStorage.setItem('section23Type', 'prarupNivada');
                                setSubComponent("Section23");
                            }}
                        >
                            <FileText className="mr-2 h-5 w-5" />
                            प्रारुप निवाडा (Section-23)
                        </button>

                    </div>
                </div>
            </div>

            {/* Error Message */}
            {error && (
                <div className="mx-6 mb-4 p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg">
                    <div className="flex items-center justify-between">
                        <span>{error}</span>
                        <button
                            onClick={() => setError(null)}
                            className="text-red-700 hover:text-red-900"
                        >
                            <X className="h-4 w-4" />
                        </button>
                    </div>
                    <button
                        onClick={fetchFinalAwardData}
                        className="mt-2 px-3 py-1 bg-red-600 text-white text-sm rounded hover:bg-red-700"
                    >
                        {translations[language].retry}
                    </button>
                </div>
            )}

            {/* Main Table */}
            <div className="p-6">
                <div className="bg-white border-2 border-gray-300 rounded-lg overflow-hidden">
                    <div className="overflow-x-auto" ref={tableRef}>
                        <table className="min-w-full text-xs">
                            <thead className="bg-gradient-to-r from-gray-100 to-gray-200">
                                {/* First Header Row */}
                                <tr>

                                    {/* <th className="no-print px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" rowSpan="2">
                                        {translations[language]?.Actions}
                                    </th> */}

                                    <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" rowSpan="2">
                                        {translations[language]?.srNo}
                                    </th>
                                    {/* <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" rowSpan="2">
                      Land Owner ID
                    </th> */}
                                    <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" rowSpan="2">
                                        {translations[language]?.OccupantName}
                                    </th>
                                    <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" rowSpan="2">
                                        {translations[language]?.GatNumber}
                                    </th>

                                    <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" colSpan="3">
                                        {translations[language]?.areaAcquired}
                                    </th>
                                    {/* <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700 " colSpan="3">
                      Total Area of Survey Number
                    </th> */}
                                    <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" rowSpan="2">
                                        {translations[language]?.RecordedValuePartialRate}
                                    </th>
                                    <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" rowSpan="2">
                                        {translations[language]?.RecordedValuePartialMarket}
                                    </th>
                                    {/* <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700 bg-yellow-50" colSpan="5">
                      Compensation Count
                    </th> */}
                                    <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" rowSpan="2">
                                        {translations[language]?.MarketValueDoubleFactor} (No.8 * 2 Factor)
                                    </th>
                                    <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" rowSpan="2">
                                        {translations[language]?.TreeValuation}
                                    </th>
                                    <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" rowSpan="2">
                                        {translations[language]?.ConstructionValue}
                                    </th>
                                    <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" rowSpan="2">
                                        {translations[language]?.WellBorewell}
                                    </th>

                                    <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" rowSpan="2">
                                        {translations[language]?.ForestTreeValuation}
                                        {/* {translations[language]?.RecordedValuePartialMarket} (Sum of columns 9+10+11+12+13) */}
                                    </th>
                                    <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" rowSpan="2">
                                        {translations[language]?.TotalAmount}
                                    </th>
                                    <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" rowSpan="2">
                                        {/* {translations[language]?.ReliefAmount100} */}
                                        {translations[language]?.ReliefAmount100}
                                    </th>
                                    <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" rowSpan="2">
                                        12% {translations[language]?.InterestAmountFrom} 25-05-2018 to 05-04-2023
                                    </th>
                                    <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" rowSpan="2">
                                        {translations[language]?.Pipeline}
                                    </th>
                                    <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" rowSpan="2">
                                        {translations[language]?.TotalSecondAmount} (Sum of 14+15+16+17)
                                    </th>
                                    <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" rowSpan="2">
                                        50% {translations[language]?.AdvanceCompDeduction}
                                    </th>
                                    <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" rowSpan="2">
                                        50% {translations[language]?.AdvanceInterestDeduction}
                                    </th>
                                    <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700" rowSpan="2">
                                        {translations[language]?.NetPayableAmount}
                                    </th>

                                </tr>

                                {/* Second Header Row */}
                                <tr>
                                    <th className="px-3 py-2 border border-gray-300 text-center font-bold text-gray-700 bg-blue-50">{translations[language]?.RecordedAreaIrrigable}</th>
                                    <th className="px-3 py-2 border border-gray-300 text-center font-bold text-gray-700 bg-blue-50">{translations[language]?.NonIrrigable}</th>
                                    <th className="px-3 py-2 border border-gray-300 text-center font-bold text-gray-700 bg-blue-50">{translations[language]?.TotalAquare}</th>
                                    {/* <th className="px-3 py-2 border border-gray-300 text-center font-bold text-gray-700 ">Ha</th>
                    <th className="px-3 py-2 border border-gray-300 text-center font-bold text-gray-700 ">Are</th>
                    <th className="px-3 py-2 border border-gray-300 text-center font-bold text-gray-700 ">Sq.M</th>
                    <th className="px-3 py-2 border border-gray-300 text-center font-bold text-gray-700 bg-yellow-50">Land</th>
                    <th className="px-3 py-2 border border-gray-300 text-center font-bold text-gray-700 bg-yellow-50">Structure</th>
                    <th className="px-3 py-2 border border-gray-300 text-center font-bold text-gray-700 bg-yellow-50">Tree</th>
                    <th className="px-3 py-2 border border-gray-300 text-center font-bold text-gray-700 bg-yellow-50">Others</th>
                    <th className="px-3 py-2 border border-gray-300 text-center font-bold text-gray-700 bg-yellow-50">Total (₹)</th> */}
                                </tr>

                            </thead>

                            <tbody className="bg-white">

                                <tr>
                                    {/* <th className="no-print px-3 py-3 border border-gray-300 text-center font-bold text-gray-700"></th> */}
                                    <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700">1</th>
                                    <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700">2</th>
                                    <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700">3</th>
                                    <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700 bg-blue-50">4</th>
                                    <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700 bg-blue-50">5</th>
                                    <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700 bg-blue-50">6</th>
                                    <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700">7</th>
                                    <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700">8</th>
                                    <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700">9</th>
                                    <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700">10</th>
                                    <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700">11</th>
                                    <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700">12</th>
                                    <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700">13</th>
                                    <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700 bg-green-100">14</th>
                                    <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700">15</th>
                                    <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700">16</th>
                                    <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700">17</th>
                                    <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700 bg-green-100">18</th>
                                    <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700">19</th>
                                    <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700">20</th>
                                    <th className="px-3 py-3 border border-gray-300 text-center font-bold text-gray-700 bg-green-100">21</th>
                                </tr>
                                {loading ? (
                                    <tr>
                                        <td colSpan="21" className="px-6 py-12 text-center">
                                            <div className="flex flex-col items-center justify-center space-y-3">
                                                <Loader className="w-8 h-8 animate-spin text-blue-500" />
                                                <div className="text-gray-500 font-medium">{translations[language].loadingCompensationRecords}</div>
                                            </div>
                                        </td>
                                    </tr>
                                ) : (
                                    <>
                                        {finalAwardData.map((row, index) => {
                                            const recordId = row.landOwnerId || row.id || row.compId;
                                            // const isSelected = selectedOwners.includes(recordId);

                                            return (
                                                <tr
                                                    key={row.landOwnerId || index}
                                                    className={`hover:bg-blue-50/50 transition-colors duration-150 "
                              }`}
                                                >
                                                    {/* {userRole === 3 && (
                            <td className="px-3 py-3 border border-gray-300 text-center">
                              <input
                                type="checkbox"
                                checked={isSelected}
                                onChange={() => handleOwnerSelection(row)}
                                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 focus:ring-2"
                              />
                            </td>
                      )} */}
                                                    {/* <td className="no-print px-2 py-3 border border-gray-300 text-center">
                                                        <button
                                                            className="px-2 py-1 text-sm bg-blue-600 text-white rounded hover:bg-blue-700"
                                                            onClick={() => FinalAwardNotice.downloadSingle(row.rawData)}
                                                        >
                                                            {translations[language].tabaPavti}
                                                        </button>
                                                    </td> */}
                                                    <td className="px-3 py-3 border border-gray-300 text-center font-medium">
                                                        {index + 1} {row.owner_aqr_area}
                                                    </td>
                                                    {/* <td className="px-3 py-3 border border-gray-300 text-center font-medium text-blue-600">
                              {row.landOwnerId || 'N/A'}
                            </td> */}
                                                    <td className="px-3 py-3 border border-gray-300 text-left">
                                                        {row.owner_name || 'N/A'}
                                                    </td>
                                                    <td className="px-3 py-3 border border-gray-300 text-center font-medium text-blue-600">
                                                        {row.surveyNo || 'N/A'}
                                                    </td>

                                                    <td className="px-3 py-3 border border-gray-300 text-center bg-blue-50">
                                                        {row.irrigableArea || 0}
                                                    </td>
                                                    <td className="px-3 py-3 border border-gray-300 text-center bg-blue-50">
                                                        {row.nonIrrigableArea || 0}
                                                    </td>
                                                    <td className="px-3 py-3 border border-gray-300 text-center bg-blue-50">
                                                        {row.ownerAquareArea || 0}
                                                    </td>
                                                    <td className="px-3 py-3 border border-gray-300 text-center ">
                                                        {row.landRate || 0}
                                                    </td>
                                                    <td className="px-3 py-3 border border-gray-300 text-center ">
                                                        {row.landAmount || 0}
                                                    </td>
                                                    <td className="px-3 py-3 border border-gray-300 text-center ">
                                                        {row.landAmount * 2 || 0}
                                                    </td>
                                                    <td className="px-3 py-3 border border-gray-300 text-center">
                                                        {row.treeCompensation || 0}
                                                    </td>
                                                    <td className="px-3 py-3 border border-gray-300 text-center">
                                                        {row.homeCompensation + row.tinshedCompensation || 0}
                                                    </td>
                                                    <td className="px-3 py-3 border border-gray-300 text-center">
                                                        {row.waterBodyCompensation + row.borewellCompensation || 0}
                                                    </td>
                                                    <td className="px-3 py-3 border border-gray-300 text-center ">
                                                        {row.forestTreeCompensation || 0}
                                                    </td>
                                                    <td className="px-3 py-3 border border-gray-300 text-center bg-green-100">
                                                        {row.firstTotal || 0}
                                                    </td>
                                                    <td className="px-3 py-3 border border-gray-300 text-center">
                                                        {row.solatium30 || 0}
                                                    </td>
                                                    <td className="px-3 py-3 border border-gray-300 text-center">
                                                        {row.interestAward || 0}
                                                    </td>
                                                    <td className="px-3 py-3 border border-gray-300 text-center">
                                                        {row.pipelineCompensation}
                                                    </td>
                                                    <td className="px-3 py-3 border border-gray-300 text-center bg-green-100">
                                                        {row.secondTotal || 0}
                                                    </td>
                                                    <td className="px-3 py-3 border border-gray-300 text-center">
                                                        {0}
                                                    </td>
                                                    <td className="px-3 py-3 border border-gray-300 text-center">
                                                        {0}
                                                    </td>
                                                    <td className="px-3 py-3 border border-gray-300 text-center font-bold bg-green-100">
                                                        {row.thirdTotal || 0}
                                                    </td>

                                                </tr>
                                            );
                                        })}


                                    </>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>

            {/* Enhanced Confirmation Dialog */}
            {showConfirm && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded-lg shadow-xl max-w-md w-full mx-4">
                        <h3 className="text-lg font-semibold text-gray-800 mb-4">
                            {translations[language].downloadFinalVerdict}
                        </h3>
                        <p className="text-gray-600 mb-6">{translations[language].choosePreferredDownload}:</p>

                        <div className="space-y-3 mb-6">
                            {/* PDF Download */}
                            <button
                                onClick={generatePDFDownload}
                                disabled={downloading}
                                className="w-full flex items-center justify-center space-x-2 px-4 py-3 bg-red-500 hover:bg-red-600 disabled:bg-gray-400 text-white rounded-lg transition-colors"
                            >
                                {downloading ? (
                                    <Loader className="h-4 w-4 animate-spin" />
                                ) : (
                                    <Download className="h-4 w-4" />
                                )}
                                <span>{translations[language].downloadPDF}</span>
                            </button>

                            {/* CSV Download */}
                            <button
                                onClick={downloadCSV}
                                disabled={downloading}
                                className="w-full flex items-center justify-center space-x-2 px-4 py-3 bg-green-500 hover:bg-green-600 disabled:bg-gray-400 text-white rounded-lg transition-colors"
                            >
                                {downloading ? (
                                    <Loader className="h-4 w-4 animate-spin" />
                                ) : (
                                    <Download className="h-4 w-4" />
                                )}
                                <span>📊 {translations[language].downloadCSV}</span>
                            </button>

                        </div>

                        <div className="flex justify-end">
                            <button
                                onClick={() => setShowConfirm(false)}
                                disabled={downloading}
                                className="px-4 py-2 bg-gray-300 hover:bg-gray-400 disabled:bg-gray-200 rounded-lg transition-colors"
                            >
                                {translations[language].cancel}
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {showConfirmationModal && (
                <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
                    <div className="bg-white rounded-xl shadow-lg p-6 w-full max-w-md">
                        <div className="flex items-center mb-4">
                            <div className="bg-red-100 p-2 rounded-full mr-3">
                                <svg className="w-6 h-6 text-red-600" fill="currentColor" viewBox="0 0 20 20">
                                    <path d="M18 10c0 4.418-3.582 8-8 8s-8-3.582-8-8 3.582-8 8-8 8 3.582 8 8zm-8 3a1 1 0 100-2 1 1 0 000 2zm1-7H9v4h2V6z" />
                                </svg>
                            </div>
                            <h3 className="text-lg font-semibold text-gray-800">{translations[language].youAreAboutToProceed}</h3>
                        </div>
                        <p className="text-sm text-gray-600 mb-6">
                            {translations[language].confirmationPendingSurveys}
                        </p>
                        <div className="flex justify-end gap-3">
                            <button
                                className="px-4 py-2 bg-gray-100 text-gray-700 rounded hover:bg-gray-200"
                                onClick={() => setShowConfirmationModal(false)}
                            >
                                {translations[language].no}
                            </button>
                            <button
                                className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
                                onClick={() => {
                                    setShowConfirmationModal(false);
                                    if (onConfirmAction) onConfirmAction();
                                }}
                            >
                                {translations[language].yesContinue}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default HighwaySelectFormat;